export default __webpack_public_path__ + "static/media/placeholder_dummy-2014-store03-de.9563587d.png";